import { Component, ElementRef, OnInit, Input } from '@angular/core';
import { globals } from '../globals';
import { Subscription } from 'rxjs';
import { Configuracao } from '../models/configuracao';
import { AutenticacaoService } from '../services/autenticacao.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificacaoService } from '../services/notificacao.service';
import { CarregandoService } from '../services/carregando.service';
import { MatDialog } from '@angular/material';
import { GlobalService } from '../services/global.service';
import { AppConfigService } from '../services/app-config.service';
import { IdentidadeVisualService } from '../services/identidade-visual.service';
import { RastreioService } from '../services/rastreio.service';
import { EtapaRastreio } from '../models/etapa-rastreio';
import { Rastreio } from '../models/rastreio';
import { RastreioLog } from '../models/rastreio-log';
import { EtapaRastreioService } from '../services/etapa-rastreio.service';
import { PlatformLocation } from '@angular/common';

declare let $: any;

@Component({
  selector: 'app-rastreio',
  templateUrl: './rastreio.component.html',
  styleUrls: ['./rastreio.component.scss']
})
export class RastreioComponent implements OnInit {
  @Input() origem: number; // 0 - Modal | 1 - Link Externo
  @Input() idCupom: string;
  token = '';
  link = '';
  @Input() etapasRastreio: EtapaRastreio[] = [];
  @Input() rastreio: Rastreio[] = [];
  @Input() logsRastreio: RastreioLog[] = [];
  etapaAtual = 2;
  transportadoraAtual: string | null = null;
  atualizacao;

  private nativeElement: Node;

  constructor(
    private element: ElementRef,
    private autenticacaoService: AutenticacaoService,
    private router: Router,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private globalService: GlobalService,
    private appConfigService: AppConfigService,
    private identidadeVisualService: IdentidadeVisualService,
    private rastreioService: RastreioService,
    private etapasRastreioService: EtapaRastreioService,
    private platformLocation: PlatformLocation,
  ) {
    this.nativeElement = element.nativeElement;
  }

  ngOnInit() {
    if (this.origem === 0) {
      this.buscarEtapas();
      this.buscarRastreio();
      this.buscarLogRastreio();
      this.buscarLinkRastreio();
    } else {
      this.verificaEtapaAtual();
    }
  }

  buscarEtapas() {
    this.carregandoService.mostra("buscaEtapas");

    this.etapasRastreioService.consultar().subscribe(data => {
      this.etapasRastreio = data;
      this.carregandoService.esconde("buscaEtapas");
    }, (erro) => {
      this.carregandoService.esconde("buscaEtapas");
      this.notificacaoService.erro(erro);
    })
  }

  buscarRastreio() {
    this.carregandoService.mostra("buscaRastreio");

    this.rastreioService.consultarRastreio(this.idCupom).subscribe(data => {
      this.carregandoService.esconde("buscaRastreio");
      this.rastreio = data;
      this.verificaEtapaAtual();
    }, (erro) => {
      this.carregandoService.esconde("buscaRastreio");
      this.notificacaoService.erro(erro);
    });
  }

  verificaEtapaAtual() {
    if (!this.rastreio || this.rastreio.length === 0) {
      this.etapaAtual = 0;
      this.transportadoraAtual = null;
      return;
    }

    const etapaAtual = this.rastreio[this.rastreio.length - 1];

    if (!etapaAtual) {
      this.etapaAtual = 0;
      this.transportadoraAtual = null;
      return;
    }

    const etapaEncontrada = this.rastreio.find(r => r.idEtapa === etapaAtual.idEtapa);

    this.etapaAtual = etapaAtual.ordem;
    this.transportadoraAtual = etapaEncontrada ? etapaEncontrada.transportadora : null;
    this.atualizacao = etapaEncontrada ? etapaEncontrada.dataHora : null;
  }

  buscarLogRastreio() {
    this.carregandoService.mostra("buscaLogRastreio");

    this.rastreioService.consultarLogRastreio(this.idCupom).subscribe(data => {
      this.carregandoService.esconde("buscaLogRastreio");
      this.logsRastreio = data;
    }, (erro) => {
      this.carregandoService.esconde("buscaLogRastreio");
      this.notificacaoService.erro(erro);
    });
  }

  buscarLinkRastreio() {
    this.carregandoService.mostra("buscarLink");

    localStorage.setItem('urlApi', globals.apiUrl);

    const url = location.origin + this.platformLocation.getBaseHrefFromDOM();

    this.rastreioService.consultarLink(this.idCupom, url).subscribe(data => {
      this.link = data.link;
      this.carregandoService.esconde("buscarLink");
    }, (erro) => {
      this.carregandoService.esconde("buscarLink");
      this.notificacaoService.erro("Não foi possível criar o link para rastreio externo: " + erro.error);
    });
  }

  copiarUrl(texto: string) {
    this.notificacaoService.sucesso(texto);
  }

  abrirJanela(url: string) {
    window.open(url, '_blank');
  }
}
